import { faCheckSquare, faSquare } from "@fortawesome/free-solid-svg-icons";
import Avatar from "components/Avatar";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useToasts } from "react-toast-notifications";
import WellnessService from "services/WellnessService";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import { Scrollbar } from "react-scrollbars-custom";
import { ReactComponent as Checkbox } from "assets/img/icons/checkbox.svg";
import { ReactComponent as UnCheckBox } from "assets/img/icons/uncheckbox.svg";
import Button from "components/CustomButton";
import Loader from "components/Loader";

var styles = {
  headingDailog: {
    fontWeight: "600",
  },
  listIteamHeading: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
    gap: "15px",
    borderBottom: "1px solid #ccc",
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderBottom: "1px solid #ccc",
  },
  teamDetail: {
    display: "flex",
    gap: "10px",
    fontWeight: "400",
    alignItems: "center",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dialogContent: {
    height: "450px",
    maxHeight: "450px",
    overflow: "auto",
    flex: "1 1 auto",
    padding: "8px 24px",
  },
  avatar: {
    minHeight: "30px",
    height: "30px",
    minWidth: "30px",
    width: "30px",
    borderRadius: "50%",
  },
  teamNameAll: {
    fontWeight: "bolder",
  },
  uncheckbox: {
    width: "20px",
    height: "20px",
  },
  checkbox: {
    width: "23px",
    height: "23px",
  },
  rightButton: {
    position: "absolute",
    top: "0",
    right: "0",
  },
  noTeams: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  shareButton: {
    cursor: "pointer",
  },
  loaderClass: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  dialogTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "0 0 auto",
    margin: 0,
    padding: "12px 0px 12px",
  },
  doneButton: {
    width: "100px",
    background: "none",
    height: "unset",
    color: "#ffa100",
    boxShadow: "unset",
  },
};

const ShareCompanyCultureVideo = ({ onClose, videoId }) => {
  const classes = styles;
  const [checkedTeams, setCheckedTeams] = useState([]);
  const [allSelectDeSel, setAllSelectDeSel] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const params = useParams();
  const { teams } = useSelector((state) => state.teamsReducer);
  const { addToast } = useToasts();

  const submitValues = async () => {
    try {
      setSubmitting(true);
      await WellnessService.shareVideoThroughTeams(videoId, {
        team_ids: checkedTeams,
      });
      addToast("Content is shared through selected teams.", {
        appearance: "success",
      });
      setSubmitting(false);
      onClose();
    } catch ({ response }) {
      addToast(response?.data?.message, {
        appearance: "error",
      });
      setSubmitting(false);
    }
  };

  const handleSelectOrDeselect = () => {
    setAllSelectDeSel(!allSelectDeSel);
    setCheckedTeams(!allSelectDeSel ? teams.map((e) => e.id) : []);
  };

  const handleTeamCheck = (target, id) => {
    if (target) {
      setCheckedTeams((prev) => [...prev, id]);
    } else {
      setCheckedTeams((prev) => prev.filter((e) => e !== id));
    }
  };

  useEffect(() => {
    setAllSelectDeSel(checkedTeams.length === teams.length);
  }, [checkedTeams, teams.length]);

  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "shareModalPadding",
      }}
      showCloseIcon={false}
      open
      onClose={onClose}
    >
      <div className="modal fade popup-modal">
        <div className="modal-content">
          <div className="modal-body">
            <div style={classes.listContainer}>
              <div style={classes.dialogTitle}>
                <h5 style={classes.headingDailog}>Select Teams</h5>
                {teams?.length > 0 && (
                  <div style={classes.rightButton}>
                    <Button
                      buttonStyle={classes.doneButton}
                      onClick={submitValues}
                      type="button"
                      name={
                        !submitting ? "Done" : <Loader width={20} height={20} />
                      }
                      disabled={(teams.length === 0 || submitting) && true}
                    />
                  </div>
                )}
              </div>
              <Scrollbar
                style={{
                  paddingRight: "10px",
                  height: "60vh",
                }}
              >
                {teams?.length > 0 && (
                  <div style={classes.listIteamHeading}>
                    <div style={classes.teamDetail}>
                      <span style={classes.teamNameAll}>
                        {checkedTeams.length === teams.length
                          ? "Deselect All"
                          : "Select All"}
                      </span>
                    </div>
                    {checkedTeams.length !== teams.length && (
                      <UnCheckBox
                        onClick={handleSelectOrDeselect}
                        style={classes.uncheckbox}
                      />
                    )}
                    {checkedTeams.length === teams.length && (
                      <Checkbox
                        onClick={handleSelectOrDeselect}
                        style={classes.checkbox}
                      />
                    )}
                  </div>
                )}
                {teams
                  ?.filter((t) => t.id !== Number(params.teamId))
                  ?.map((allteam) => (
                    <div style={classes.listItem} key={allteam.id}>
                      <div style={classes.teamDetail}>
                        <Avatar
                          alt={allteam.avatar}
                          rootStyle={classes.avatar}
                          src={allteam.avatar ?? DefaultTeamAvatar}
                        />
                        <span style={classes.teamName}>{allteam.name}</span>
                      </div>
                      {!checkedTeams.includes(allteam.id) && (
                        <UnCheckBox
                          icon={faSquare}
                          style={classes.uncheckbox}
                          onClick={() => {
                            handleTeamCheck(true, allteam.id);
                          }}
                        />
                      )}
                      {checkedTeams.includes(allteam.id) && (
                        <Checkbox
                          icon={faCheckSquare}
                          style={classes.checkbox}
                          onClick={() => {
                            handleTeamCheck(false, allteam.id);
                          }}
                        />
                      )}
                    </div>
                  ))}
                {teams?.length === 0 && (
                  <div style={classes.noTeams}>
                    <p>You don't have any teams.</p>
                  </div>
                )}
              </Scrollbar>
            </div>
            <div>
              <Button
                type="button"
                disabled={submitting && true}
                buttonClass="small-btn me-2"
                name="Cancel"
                onClick={onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShareCompanyCultureVideo;
